import { createAction } from 'typesafe-actions';

export const selectThemeName = createAction('theme/SELECT_THEME_NAME')<string>();
export const detectThemeName = createAction('theme/DETECT_THEME_NAME')<void>();
